module.exports = __webpack_public_path__ + "static/media/facebooklogo.f25ded63.svg";